import { UserManager } from 'oidc-client';

//uncomment scope while using in local env
const settings = {
    authority: process.env.REACT_APP_KEYCLOACK_AUTHORITY_URL,
    client_id: process.env.REACT_APP_KEYCLOACK_CLIENT_ID,
    redirect_uri: window.location.origin + process.env.REACT_APP_KEYCLOACK_CALLBACK_URL,
    response_type: process.env.REACT_APP_KEYCLOACK_RESPONSE,
    //   scope: "openid profile message.read",
    post_logout_redirect_uri: process.env.REACT_APP_KEYCLOACK_POST_LOGOUT,
    automaticSilentRenew: true,
    silent_redirect_uri: `${window.location.origin}/silent-renew.html`,
};

export const userManager = new UserManager(settings);

export const getUser = () => {
    return userManager.getUser();
}

export const login = () => {
    return userManager.signinRedirect();
}


// Force a fresh login prompt (no SSO auto-login)
export const forceLogin = () => {
  return userManager.signinRedirect({ prompt: 'login' });
};

// Everything the portal keeps for a signed-in user lives in sessionStorage:
// tokens, the selected country codes, per-grid column choices, the last tab a
// module was on... Wiping the lot on the way out is what keeps the next login
// from inheriting the previous user's screen state. The OIDC user is read
// first because oidc-client stores it in sessionStorage too.
const clearSessionState = () => {
  try {
    sessionStorage.clear();
  } catch (error) {
    // best-effort; a blocked storage must not stop the sign-out redirect
  }
};

export const logout = async () => {
  try {
    const user = await userManager.getUser();
    const idToken = user?.id_token;
    // Trigger logout across all tabs
    localStorage.setItem('logout', Date.now());
    clearSessionState();
    if (idToken) {
      await userManager.signoutRedirect({ id_token_hint: idToken });
    } else {
      window.location.href = process.env.REACT_APP_KEYCLOACK_POST_LOGOUT;
    }
  } catch (error) {
    // Trigger logout across all tabs
    localStorage.setItem('logout', Date.now());
    clearSessionState();
    window.location.href = process.env.REACT_APP_KEYCLOACK_POST_LOGOUT;
  }
};


